var cx = require("classnames");

const CharactersRemaining = (props) => {
  var remaningCharacters = props.stringLimit - props.stringToWatch.length || 0;

  var limitForWarn = props.limitForWarn;
  var limitForRed = props.limitForRed;

  var className = cx(
    props.className,
    {
      "c-warn": (
        remaningCharacters <= props.limitForWarn &&
        remaningCharacters > limitForRed
      ),
      "c-red": (remaningCharacters <= limitForRed)
    }
  );

  return (
    <span className={className}>
      {remaningCharacters}
    </span>
  );
};

CharactersRemaining.propTypes = {
  stringLimit: React.PropTypes.number.isRequired,
  stringToWatch: React.PropTypes.string,
  limitForWarn: React.PropTypes.number,
  limitForRed: React.PropTypes.number,
  className: React.PropTypes.string
};

CharactersRemaining.defaultProps = {
  stringToWatch: "",
  limitForWarn: 20,
  limitForRed: 10
};

module.exports = CharactersRemaining;



// WEBPACK FOOTER //
// ./app/shared/components/CharactersRemaining/characters-remaining.jsx